import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const SingleReview = () => {
    return (
        <>
            <Header as="h1" id="review-header">Single Review</Header>
        </>
    );
};

export default SingleReview;